(() => {
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  const mobile = matchMedia('(max-width: 989px)');
  function init(root = document) {
    root.querySelectorAll('[data-nav-menu]').forEach(menu => {
      if (menu.dataset.ready) return;
      menu.dataset.ready = 'true';
      menu.addEventListener('toggle', () => { menu.querySelector('summary').title = menu.open ? 'Close menu' : 'Open menu'; });
      menu.addEventListener('keydown', e => { if (e.key === 'Escape') { menu.open = false; menu.querySelector('summary').focus(); } });
      menu.addEventListener('click', e => { if (e.target.closest('a')) menu.open = false; });
      mobile.addEventListener('change', () => { menu.open = false; });
    });
    root.querySelectorAll('[data-product-interest]').forEach(field => {
      if (field.dataset.synced) return;
      field.dataset.synced = 'true';
      const initial = field.value;
      const initialHandle = field.form?.querySelector('[data-product-handle]')?.value || '';
      field.addEventListener('input', () => {
        field.form.querySelectorAll('[data-product-handle]').forEach(input => {
          input.value = field.value === initial ? initialHandle : '';
        });
        root.querySelectorAll('[data-selected-product]').forEach(label => { label.textContent = field.value || 'Choose a product below'; });
      });
    });
    root.querySelectorAll('[data-film]').forEach(film => {
      if (film.dataset.ready) return;
      film.dataset.ready = 'true';
      const videos = [...film.querySelectorAll('[data-dryzane-video]')];
      const toggle = film.querySelector('[data-film-toggle]');
      if (!videos.length || !toggle) return;
      let visible = true, pausedByUser = false, requested = false;
      const active = () => videos.find(v => v.dataset.viewport === (mobile.matches ? 'mobile' : 'desktop'));
      const label = () => {
        const video = active(), paused = !video || video.paused;
        toggle.hidden = !video;
        toggle.setAttribute('aria-label', paused ? 'Play film' : 'Pause film');
        toggle.title = paused ? 'Play film' : 'Pause film';
        toggle.querySelector('[data-film-play]').hidden = !paused;
        toggle.querySelector('[data-film-pause]').hidden = paused;
      };
      const update = () => {
        const video = active();
        videos.forEach(v => { if (v !== video) v.pause(); });
        if (!video || !visible || document.hidden || pausedByUser || ((motion.matches || navigator.connection?.saveData) && !requested)) {
          video?.pause(); label(); return;
        }
        if (!video.dataset.loaded) {
          video.querySelectorAll('source[data-src]').forEach(s => { s.src = s.dataset.src; });
          video.dataset.loaded = 'true'; video.load();
        }
        video.play().catch(label);
      };
      videos.forEach(v => { v.addEventListener('play', label); v.addEventListener('pause', label); });
      toggle.addEventListener('click', () => {
        const v = active(); if (!v) return;
        pausedByUser = !v.paused; requested = v.paused; update();
      });
      mobile.addEventListener('change', update);
      motion.addEventListener('change', () => { requested = false; update(); });
      document.addEventListener('visibilitychange', update);
      if ('IntersectionObserver' in window) new IntersectionObserver(([e]) => { visible = e.isIntersecting; update(); }, { threshold: .05 }).observe(film);
      update();
    });
    root.querySelectorAll('.dryzane-product__gallery').forEach(gallery => {
      if (gallery.dataset.ready) return;
      gallery.dataset.ready = 'true';
      const figures = [...gallery.querySelectorAll('.dryzane-product__media')];
      if (!figures.length) return;
      let index = 0, previousFocus;
      const thumbs = document.createElement('div');
      thumbs.className = 'dryzane-gallery-thumbs';
      thumbs.setAttribute('aria-label', 'Product views');
      const controls = document.createElement('div');
      controls.className = 'dryzane-gallery-tools';
      const count = document.createElement('span');
      count.setAttribute('aria-live', 'polite');
      const zoom = document.createElement('button');
      zoom.type = 'button'; zoom.textContent = 'Enlarge image'; zoom.title = 'Open full image';
      zoom.setAttribute('aria-label', 'Enlarge image');
      const zoomIcon = gallery.querySelector('[data-gallery-zoom-icon]');
      if (zoomIcon) zoom.replaceChildren(zoomIcon.content.cloneNode(true));
      const dialog = document.createElement('dialog');
      dialog.className = 'dryzane-lightbox'; dialog.setAttribute('aria-label', 'Enlarged product image');
      const full = document.createElement('img'), close = document.createElement('button');
      close.type = 'button'; close.textContent = '\u00d7'; close.setAttribute('aria-label', 'Close image'); close.title = 'Close image';
      dialog.append(close, full); document.body.append(dialog);
      const open = () => {
        const img = figures[index].querySelector('img'); if (!img) return;
        previousFocus = document.activeElement;
        full.src = img.dataset.fullSrc || img.currentSrc || img.src; full.alt = img.alt;
        dialog.showModal(); document.documentElement.style.overflow = 'hidden';
      };
      close.addEventListener('click', () => dialog.close());
      dialog.addEventListener('close', () => { document.documentElement.style.overflow = ''; previousFocus?.focus(); });
      zoom.addEventListener('click', open);
      const select = next => {
        index = (next + figures.length) % figures.length;
        figures.forEach((figure, i) => {
          figure.hidden = i !== index;
          if (i !== index) figure.querySelectorAll('video').forEach(v => v.pause());
        });
        [...thumbs.children].forEach((button, i) => button.setAttribute('aria-pressed', String(i === index)));
        count.textContent = String(index + 1).padStart(2, '0') + ' / ' + String(figures.length).padStart(2, '0');
        zoom.hidden = !figures[index].querySelector('img');
      };
      figures.forEach((figure, i) => {
        const img = figure.querySelector('img'), button = document.createElement('button');
        button.type = 'button'; button.setAttribute('aria-label', 'View ' + (i + 1) + (img?.alt ? ': ' + img.alt : ''));
        if (img) {
          const thumb = document.createElement('img');
          thumb.src = img.dataset.thumbSrc || img.currentSrc || img.src; thumb.alt = ''; thumb.loading = 'lazy';
          button.append(thumb); img.dataset.zoomable = 'true'; img.addEventListener('click', open);
        } else button.textContent = 'Media ' + (i + 1);
        button.addEventListener('click', () => select(i));
        button.addEventListener('keydown', event => {
          if (!['ArrowRight', 'ArrowLeft'].includes(event.key)) return;
          event.preventDefault(); select(index + (event.key === 'ArrowRight' ? 1 : -1)); thumbs.children[index].focus();
        });
        thumbs.append(button);
      });
      let start;
      gallery.addEventListener('touchstart', event => { start = event.touches[0]; }, { passive: true });
      gallery.addEventListener('touchend', event => {
        if (!start || event.target.closest('button')) return;
        const dx = event.changedTouches[0].clientX - start.clientX, dy = event.changedTouches[0].clientY - start.clientY;
        if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy) * 1.5) select(index + (dx < 0 ? 1 : -1));
        start = null;
      }, { passive: true });
      controls.append(count, zoom);
      if (figures.length > 1) gallery.append(thumbs);
      gallery.append(controls); gallery.classList.add('is-enhanced'); select(0);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
